import CustomDrawer from "../shared/CustomDrawer";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Logo from "../../assets/icons/logo-name.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

export function SuccessPaymentDrawer(props) {
  const { open, setOpen, assetName } = props;
  const navigate = useNavigate();

  return (
    <CustomDrawer
      containerSx={{
        height: "100vh",
        position: "relative",
        alignItems: "center",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
      }}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
        }}
        onClick={() => {
          navigate("/app/navigation/assets");
        }}
      >
        <CloseIcon sx={{ color: "primary.main" }} />
      </IconButton>
      <img src={Logo} width={80} height={150} style={{ marginTop: 100 }} />
      <Typography mt={3} variant="h4" color="primary.main">
        درخواست شما ثبت شد
      </Typography>
      <Typography mt={2} component={"div"} variant="body2" color="grey.2">
        درخواست خرید صندوق{" "}
        <Box display={"inline"} fontWeight={"bold"}>
          {assetName}
        </Box>{" "}
        با موفقیت ثبت شد{" "}
      </Typography>
    </CustomDrawer>
  );
}
